import ModalOutcomesEventHistoryEditing from "./ModalOutcomesEventHistoryEditing";

export default ModalOutcomesEventHistoryEditing;